// Define your function to handle the click on a.t4s-pr-quickview
// $(".t4s-product-wrapper .t4s-pr-quickview, a.t4s-pr-item-btn.t4s-pr-addtocart").click(function() {
//     // Set a timeout to click on $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item") after 800 milliseconds
//     setTimeout(function() {
//         $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item.is--selected").click();
//     }, 900);
// });

// Listen for the modal to become active
// $(document).on('DOMNodeInserted', function(e) {
//     // Check if the inserted node is the modal and has the class 't4s-modal--is-active'
//     if ($(e.target).hasClass('t4s-modal') && $(e.target).hasClass('t4s-modal--is-active')) {
//         // Click the desired element inside the modal
//         $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item.is--selected").click();
//     }
// });


jQuery_T4NT(document).ready(function($) {


// $(document).on("variant:changed", function(evt) {
//     var price = evt.currentVariant.price;
//     var parentContainer = $(".t4s-product__info-container, .t4s-product-qs-inner");
    
//     // Store the amount in local storage
//     // alert(price);
 
//     var priceRequestLink = `<span><a href="https://api.whatsapp.com/send?phone=923006225159&text=Hello i am interested in {{shop.domain}}{{ product.url }}" class="t4s-pr-item-btn t4s-pr-addtocart callforpricing" rel="nofollow" target="_blank"><span class="t4s-text-pr">Price on Request</span></a></span>`;

//     if (parseFloat(price) >= 35000000) {
//         parentContainer.find(".t4s-product-form__buttons").hide();
//         parentContainer.find("span.money").remove();
//         parentContainer.find("#whatsapp").show();
//         // Only append the link if it does not already exist
//       // parentContainer.find(".t4s-product-qs__price .t4s-product-price").append(priceRequestLink);
      
//         if (parentContainer.find(".t4s-product-price").find(".callforpricing").length === 0) {
//             parentContainer.find(".t4s-product-price").append(priceRequestLink);
//         }
//         if ($(".t4s-product-qs-inner").find(".t4s-product-price").find(".callforpricing").length === 0) {
//              $(".t4s-product-qs-inner").find(".t4s-product-price").append(priceRequestLink);
//         }     
//     } else {
//         parentContainer.find(".t4s-product-form__buttons").show();
//         parentContainer.find("span.money").show();
//         parentContainer.find("#whatsapp").hide();
        
//         // Remove the "Price on Request" link if it exists
//         parentContainer.find(".callforpricing").closest('span').remove();
//     }

//     // $('[data-variant-toggle]').hide(0);
//     // $('[data-variant-toggle="' + evt.currentVariant.id + '"]').show(0);
// });
  
  
// Loop through elements with class starting with "JAVA-"


     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


});


// $(document).ready(function() {
  
//     // Function to clean the amount string
//     function cleanAmountString(amountStr) {
//         var cleanedAmountStr = amountStr.replace(/[^0-9,]/g, '');
//         cleanedAmountStr = cleanedAmountStr.replace(/,/g, '');
//         return parseFloat(cleanedAmountStr);
//     }

//     // Function to append two zeros to the price (only used on initial load)
//     function appendTwoZeros(price) {
//         return price * 100;
//     }

//     // Function to check and update price-related elements within a specific containe
  
//     function checkPriceCondition(container, price) {
      
//       const priceRequestLink = `<span><a href="https://api.whatsapp.com/send?phone=923006225159&text=Hello I am interested in ${shopDomain} ${proUrl}" class="t4s-pr-item-btn t4s-pr-addtocart callforpricing" rel="nofollow" target="_blank"><span class="t4s-text-pr">Price on Request</span></a></span>`;

//         // Find the first .money element that is not inside <del> or <ins> within the container
//         var targetSpan = container.find("span.money").not("del span.money, ins span.money").first();

//         if (targetSpan.length > 0) {
//             var targetMoneyText = targetSpan.text();
//             var targetMoneyPrice = cleanAmountString(targetMoneyText);

//             // Apply conditions based on the target span's price
//             if (targetMoneyPrice <= 0 || targetMoneyPrice >= 350000) {
//                 container.find(".t4s-product-form__buttons").hide();
//                 container.find("span.money").remove();
//                 container.find("#whatsapp").show(); // Show #whatsapp

//                 if (container.find(".t4s-product-price .callforpricing").length === 0) {
//                     container.find(".t4s-product-price").append(priceRequestLink);
//                 }
//             } else {
//                 container.find(".t4s-product-form__buttons").show();
//                 container.find("span.money").show();
//                 container.find("#whatsapp").hide(); // Hide #whatsapp

//                 container.find(".callforpricing").closest('span').remove();
//             }
//         }
//     }

//     // Initial price check on page load for each relevant container
//     $(".t4s-product__info-wrapper, .t4s-product-qs-inner").each(function() {
//         var container = $(this);
//         var initialPriceStr = container.find(".t4s-product-price .money").not("del span.money, ins span.money").first().text();

//         if (initialPriceStr) {
//             var initialPrice = cleanAmountString(initialPriceStr);
//             var formattedInitialPrice = appendTwoZeros(initialPrice);
//             checkPriceCondition(container, formattedInitialPrice);
//         }
//     });

//     // Event listener for variant change, apply the change to the specific container
//     $(document).on("variant:changed", function(evt) {
//         $(".t4s-product__info-wrapper, .t4s-product-qs-inner").each(function() {
//             var container = $(this);
//             var priceStr = evt.currentVariant.price.toString();
//             var price = cleanAmountString(priceStr);

//             // Store the amount in local storage (optional)
//             localStorage.setItem('amount_' + evt.currentVariant.id, price);

//             checkPriceCondition(container, price);
//         });
//     });

//     // Optionally, retrieve and use stored amount (example usage)
//     // var storedAmount = parseFloat(localStorage.getItem('amount_' + index));
// });

      







